import React from "react";
import { NavLink } from "react-router-dom";
import { AuthComponent } from "./AuthComponent"; // Import the new component

export const Header = () => {
  return (
    <header className="header">
      <div className="logo">DeskShare</div>
      <nav className="nav">
        <NavLink
          to="/"
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          My Overview
        </NavLink>
        <NavLink
          to="/reserve"
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          Reserve a Desk
        </NavLink>
        <NavLink
          to="/setup"
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          Setup
        </NavLink>
      </nav>
      <AuthComponent /> {/* Add the auth component here */}
    </header>
  );
};